<template>
  <div class="height100 flex flex-col">
    <div class="bg-fff margin-bottom-10">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18 font-bold">团队单位</div>
<!--        <div>-->
<!--          <el-button type="primary" size="small" @click="tocreate">-->
<!--            <i class="el-icon-plus" style="margin-right: 5px"></i>上传文档-->
<!--          </el-button>-->
<!--        </div>-->
      </div>
      <div class="global-line"></div>
<!--      <div class="global-padd-15">-->
<!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
<!--          <el-tab-pane label="资质已审核" name="first"></el-tab-pane>-->
<!--          <el-tab-pane label="资质未审核" name="second"></el-tab-pane>-->
<!--        </el-tabs>-->
<!--      </div>-->
      <div class="global-padd-15">
        <el-form v-model="form" inline>
          <el-form-item label="所属区域：">
            <el-cascader
                :show-all-levels="false"
                :change-on-select="true"
                v-model="form.areaCode"
                placeholder="选择区域"
                ref="cascader"
                @change="getOrgVal"
                :props="props"
                style="width: 180px"
                size="small"
                clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="当前会员状态：">
              <el-select size="small"
                         clearable
                         style="width: 180px"
                         v-model="form.memberState">
                  <el-option label="生效中" :value="0" ></el-option>
                  <el-option label="已过期" :value="1" ></el-option>

              </el-select>
          </el-form-item>
          <el-form-item label="成立时间：">
            <el-date-picker
                style="width: 180px"
                v-model="form.teamFoundTimeBegin"
                type="date"
                size="small"
                value-format="timestamp"
                placeholder="开始时间">
            </el-date-picker>
            -
            <el-date-picker
                v-model="form.teamFoundTimeEnd"
                type="date"
                style="width: 180px"
                size="small"
                value-format="timestamp"
                placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="审核状态：">
            <el-select size="small"
                       clearable
                       style="width: 180px"
                       v-model="form.teamCheckState">
              <el-option label="资质待审核" :value="0" ></el-option>
              <el-option label="资质通过" :value="1" ></el-option>
              <el-option label="资质不通过" :value="2" ></el-option>
              <el-option label="付费凭证待审核" :value="3" ></el-option>
              <el-option label="付费凭证通过" :value="4" ></el-option>
              <el-option label="付费凭证不通过" :value="5" ></el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="关键字：">
            <el-input size="small"
                      style="width: 180px"
                      clearable
                      v-model="form.keyword"
                      placeholder="关键字">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="searchCondition">搜索</el-button>
          </el-form-item>
          <!--                        <el-form-item>-->
          <!--                            <el-button size="small" type="primary" @click="exportT">导出</el-button>-->
          <!--                        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div class="flex margin-bottom-10 bg-fff global-padd"  >
      <div>团队单位共<span class="font-20 font-warning">{{totalCount.teamTotalCount}}</span>个，会员过期<span class="font-20 font-warning">{{totalCount.teamExpiredCount}}</span>个，付款资质待审核<span class="font-20 font-warning">{{totalCount.teamPayNeedCheckCount}}</span>个，团队成员待审核共<span class="font-20 font-warning">{{totalCount.teamMemberNeedCheckCount}}</span>个</div>
    </div>
    <div class="flex1">
      <el-table height="100%" :data="tableData"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="团队名称"   prop="teamName" >
        </el-table-column>
        <el-table-column label="所在单位"  prop="parentUnit">
        </el-table-column>
        <el-table-column label="成立时间" >
          <template slot-scope="scope">
            {{scope.row.teamFoundTime | dateFormat('yyyy-MM-dd')}}
          </template>
        </el-table-column>
        <el-table-column label="团队负责人"  prop="teamLeaderName" >
        </el-table-column>
        <el-table-column label="团队成员/教练" >
          <template slot-scope="scope">
            <div>{{scope.row.memberCount+'/'+scope.row.coachCount}}</div>
          </template>
        </el-table-column>
        <el-table-column label="所在区域" prop="areaName">
        </el-table-column>
        <el-table-column label="当前会员状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.teamExpireTime&&(new Date().getTime()>scope.row.teamExpireTime)" style="color: #4680FE">已过期</span>
            <span v-if="scope.row.teamExpireTime&&(new Date().getTime()<scope.row.teamExpireTime)" style="color: green">生效中</span>
            <span v-if="!scope.row.teamExpireTime" style="color: red">未入会</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.teamCheckState==0">资质待审核</span>
            <span v-if="scope.row.teamCheckState==1" style="color: green">资质通过</span>
            <span v-if="scope.row.teamCheckState==2">资质不通过</span>
            <span v-if="scope.row.teamCheckState==3">付费凭证待审核</span>
            <span v-if="scope.row.teamCheckState==4">付费凭证通过</span>
            <span v-if="scope.row.teamCheckState==5">付费凭证不通过</span>
          </template>
        </el-table-column>
<!--        <el-table-column label="上传时间" min-width="140">-->
<!--          <template slot-scope="scope">-->
<!--            {{scope.row.createTime | dateFormat('yyyy-MM-dd hh:mm')}}-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="审核状态"  width="100">-->
<!--          <template slot-scope="scope">-->
<!--            <span class="" v-if="scope.row.checkState==0">待审核</span>-->
<!--            <span class="font-success" v-if="scope.row.checkState==1">已同意</span>-->
<!--            <span class="font-warning" v-if="scope.row.checkState==2">已驳回</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作"  prop="totalCostMoney">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.teamCheckState==0" @click="agree(scope.row)"><span style="text-decoration: underline">审核</span></el-button>
            <el-button type="text" v-if="scope.row.teamCheckState!=0" @click="toDetail(scope.row.teamId)"><span style="text-decoration: underline">查看</span></el-button>
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center global-padd bg-fff">
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="form.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="form.total">
      </el-pagination>
    </div>
    <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisible"
        width="30%"
    >
      <div>
            <el-input size="small"
                      style="width:100%"
                      rows="5"
                      clearable
                      type="textarea"
                      v-model="checkRemark"
                      placeholder="请输入驳回理由"
            >
            </el-input>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="agreeit(2)">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
        title="团队资料"
        :visible.sync="drawer"
        :direction="direction"
        >
      <div style="padding:20px;">
          <div class="flex flex-between margin-bottom-20 flex-align-center">
            <div>团队logo</div>
            <img style="width: 60px;height: 60px" :src="agreeData.teamLogo" alt="">
          </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="flex flex-between flex-align-center margin-bottom-20">
          <div>团队名称</div>
          <div>{{agreeData.teamName}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="flex flex-between flex-align-center margin-bottom-20">
          <div>成立时间</div>
          <div>{{agreeData.teamFoundTime  | dateFormat('yyyy-MM-dd')}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="flex flex-between flex-align-center margin-bottom-20">
          <div>团队负责人</div>
          <div>{{agreeData.teamLeaderName}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="flex flex-between flex-align-center margin-bottom-20">
          <div>所在单位</div>
          <div>{{agreeData.parentUnit}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="flex flex-between flex-align-center margin-bottom-20">
          <div>所在区域</div>
          <div>{{agreeData.areaName}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="margin-bottom-20 flex flex-between flex-align-center">
          <div>团队介绍</div>
          <div style="max-width: 280px; line-height: 20px">{{agreeData.teamIntro}}</div>
        </div>
        <div class="global-line margin-bottom-20"></div>
        <div class="margin-bottom-20">
          <div class="margin-bottom-20">入会资质证明</div>
          <div class="flex text-center">
            <div class=" margin-rt-15">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.businessLicenseObjectkey"
                  :preview-src-list="[agreeData.businessLicenseObjectkey]">
              </el-image>
              <div>营业执照</div>
            </div>
            <div>
              <el-image
                  style="width: 100px; height: 100px"
                  :src="agreeData.applyInfoObjectkey"
                  :preview-src-list="[agreeData.applyInfoObjectkey]">
              </el-image>
              <div>入会申请表</div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <el-button type="primary" @click="agreeit(1)">同意</el-button>
          <el-button type="danger" @click="dialogVisible=true">驳回</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'docList',
  data(){
    let _this = this
    return {
      dialogVisible:false,
      checkRemark:'',
      agreeData:{},
      drawer: false,
      direction: 'rtl',
      areaCode:'',
      // activeName:'',
      form:{
        keyword:'',
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        total:0
      },
      props: {
        emitPath:false,
        lazy: true,
        lazyLoad (node, resolve) {
            _this.loadNodeOrg(node, resolve)
        }

      },
      tagList:[],
      tableData:[],
      totalCount:{}
    }
  },
  mounted () {
    this.getList()
    this.getListTotal()
  },
  watch:{
    dialogVisible(){
      if(this.dialogVisible==false){
        this.checkRemark=undefined
      }
    }
  },
  methods:{
    dialogClose(){
      this.dialogVisible=false
    },
    agreeit(type){
      if(!this.checkRemark&&type!=1){
        this.$message.error("请填写驳回原因！")
        return
      }
      this.$confirm('确认'+(type==1?'同意':'驳回')+'吗？')
      .then(() => {
        this.$http.get('/rest/team/check', {teamId:this.agreeData.teamId,checkResult:type,checkRemark:this.checkRemark},res => {
          this.$message.success('审核完成！')
        })
        this.drawer=false
        this.dialogVisible=false
        setTimeout(this.getList,1000)
      })
      .catch(() => {});

    },
    agree(data){
      this.drawer=true
      this.agreeData=data
    },
    loadNodeOrg (node, resolve) {
      // console.log(464564)
      // console.log(node)
      let url = '/rest/public/nation/area/list'
      this.$http.get(url, {areaCode:node.level === 0?'':node.data.areaCode},res => {
        let datas = []
        // console.log(res)
        res.forEach(item => {
          let data = {
            value: item.areaCode,
            label: item.areaName,
            areaCode: item.areaCode
          }
          // if (item.parentAreaCode < 4) {
            data.leaf = false
          // } else {
          //   data.leaf = true
          // }
          datas.push(data)
        })
        resolve(datas)
      })
    },
    getOrgVal(val){
      // console.log(val,this.$refs['cascader'].getCheckedNodes()[0].label)
      // this.orgName=this.$refs['cascader'].getCheckedNodes()[0].label
      this.$refs['cascader'].dropDownVisible = false;
    },
    handleClick(){},

    searchCondition(){
      this.form.page=1
      this.getList()
    },
    handleCurrentChange(a){
      this.form.page=a
      this.getList()
    },
    getList(){
      this.$http.post('/rest/team/manage/list', this.form, res => {
        this.tableData=res.data
        this.form.total=res.total
      })
    },
    getListTotal(){
      this.$http.post('/rest/summary/team', this.form, res => {
          this.totalCount=res
      })
    },
    toDetail(id){
     // this.openNewPage('/teammanagement/detail/'+id)
     this.$router.push('/teammanagement/detail/'+id)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/vipManagement/team/list.vue